import { changeAccountStatusBulkActionType, systemStatuses, } from '../../../../../../backend/features/accounts/shared';
import { useUserState } from '../../../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { showConfirmDialog, showCustomDialog, showErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Button, DialogActions, DialogContent, DialogTitle, FormControl, Grid, Stack, Typography, useMediaQuery, useTheme, } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React from 'react';
import { Trans } from 'react-i18next';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
export function showChangeAccountsStatusDialog(params) {
    showCustomDialog({
        fullWidth: true,
        maxWidth: 'md',
        content: (close) => React.createElement(AccountStatusDialog, Object.assign({}, params, { onClose: close })),
    });
}
const AccountStatusDialogContent = (props) => {
    const theme = useTheme();
    const border = `1px solid ${theme.palette.divider}`;
    const downSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useContactManagementTranslation();
    const statusMessage = (hidePrefix, status) => (React.createElement(Trans, { t: t, i18nKey: `panels.accounts.changeStatus.${status}`, components: {
            hidden: React.createElement(Typography, { component: 'div', display: 'inline', hidden: hidePrefix }),
            bold: React.createElement(Typography, { component: 'div', display: 'inline', textTransform: 'uppercase', fontWeight: 'bold' }),
            green: React.createElement(Typography, { component: 'div', display: 'inline', color: 'green', textTransform: 'uppercase', fontWeight: 'bold' }),
            red: React.createElement(Typography, { component: 'div', display: 'inline', color: 'red', textTransform: 'uppercase', fontWeight: 'bold' }),
        }, "data-test": `status-${status}-explanation-text` }));
    return (React.createElement(Box, { p: 2 },
        React.createElement(FormControl, null,
            React.createElement(RadioGroup, { value: props.selectedStatus || '', onChange: props.onChange },
                React.createElement(Grid, { container: true, spacing: 2, direction: 'row', sx: { border: border, borderRadius: 1 } }, systemStatuses.map((key) => (React.createElement(React.Fragment, { key: key },
                    React.createElement(Grid, { sx: { borderBottom: border, padding: 1 }, size: downSmScreen ? 12 : 6 },
                        React.createElement(FormControlLabel, { value: key, control: React.createElement(Radio, null), label: t(`panels.accounts.status.${key}`), "data-test": `status-${key}-radio-button` })),
                    !downSmScreen && (React.createElement(Grid, { sx: { borderBottom: border, padding: 1 }, size: 6 }, statusMessage(true, key))))))))),
        downSmScreen && (React.createElement(Box, { pt: 2 },
            React.createElement(Stack, { direction: 'row', alignItems: 'center', gap: 1 },
                React.createElement(InfoOutlinedIcon, null),
                React.createElement(Typography, null, t('panels.accounts.changeStatus.aboutStatuses'))),
            systemStatuses.map((key) => (React.createElement(Box, { key: key, pt: 1 }, statusMessage(false, key))))))));
};
const AccountStatusDialog = (props) => {
    var _a;
    const userState = useUserState();
    const { t } = useContactManagementTranslation();
    const [selectedStatus, setSelectedStatus] = React.useState();
    const selectedRowIds = (_a = props.dataTableProps.selectedRowIds) !== null && _a !== void 0 ? _a : [];
    const count = selectedRowIds.length > 0 ? selectedRowIds.length : props.dataTableProps.filteredRowCount;
    const filter = selectedRowIds.length > 0 ? [{ op: 'in', id: selectedRowIds }] : props.appliedStorageFilters;
    const title = t('panels.accounts.changeStatus.dialogTitle', { count });
    const handleChange = (event) => {
        setSelectedStatus(event.target.value);
    };
    const handleChangeStatus = () => {
        if (selectedStatus) {
            launchBulkAction({
                type: changeAccountStatusBulkActionType,
                title,
                params: {
                    newStatus: selectedStatus,
                    filter: filter,
                    orderBy: [
                        {
                            column: props.dataTableProps.sortColumnKey,
                            desc: props.dataTableProps.sortColumnDesc,
                        },
                    ],
                },
                onClose: () => {
                    props.onClose();
                    props.onAfterSave();
                },
            });
        }
        else {
            showErrorDialog({ title: t('common.errorMessage') });
        }
    };
    const handleSave = () => {
        if (selectedStatus) {
            const statusName = t(`panels.accounts.status.${selectedStatus}`);
            showConfirmDialog({
                title: selectedStatus === 'deleted'
                    ? t('panels.accounts.changeStatus.confirmationMessageDelete', { count })
                    : t('panels.accounts.changeStatus.confirmationMessage', { status: statusName, count }),
                content: selectedRowIds.includes(userState.id) ? t('panels.accounts.changeStatus.currentUserNotChanged') : undefined,
                onConfirm: () => handleChangeStatus(),
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, t('panels.accounts.changeStatus.dialogTitle', { count })),
        React.createElement(DialogContent, null,
            React.createElement(AccountStatusDialogContent, { selectedStatus: selectedStatus, onChange: (event) => handleChange(event) })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => props.onClose(), "data-test": 'cancel-button' }, t('common.cancel')),
            React.createElement(Button, { color: 'primary', disabled: !selectedStatus, onClick: () => handleSave(), "data-test": 'save-button' }, t('common.save')))));
};
